export default {
      id: "lft-dark-usage",
      viewBox: "0 0 171 24",
      url: __webpack_public_path__ + "sprite.svg#lft-dark-usage",
      toString: function () {
        return this.url;
      }
    }